module.exports = __webpack_public_path__ + "593a3d53/img/mini-logo.18817ee5.svg";